import {HOST_URI} from "../constants/vars";

const API_ORIGIN = (HOST_URI || "").replace(/\/$/, "").replace(/\/graphql\/?$/, "");

export function resolveMediaUrl(url) {
    if (!url || typeof url !== "string") return url;
    if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(url) && API_ORIGIN) {
        return url.replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i, API_ORIGIN);
    }
    if (/^https?:\/\//i.test(url)) return url;
    if (!API_ORIGIN) return url;
    return `${API_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`;
}
